

































import { computed, defineComponent } from "@vue/composition-api";
import { FollowingStatistic } from "@scrile/api-provider/dist/api/FollowingsProvider";
import { getShrinkedNumber } from "@/lib/moneyHelpers";

export default defineComponent({
  name: "ProfileStatisticView",
  props: {
    userId: { type: String, required: true },
    followingStatistic: { type: Object as () => FollowingStatistic },
    postsStatistic: { type: Number, required: true },
    likesStatistic: { type: Number, required: true },
    showFollowing: { type: Boolean, default: true },
    showFollowers: { type: Boolean, default: true },
    showLikes: { type: Boolean, default: true },
  },
  setup(props) {
    const amountFollowers = computed(() => getShrinkedNumber(props.followingStatistic?.followerCount ?? 0));
    const amountFollowing = computed(() => getShrinkedNumber(props.followingStatistic?.followingCount ?? 0));
    const formattedPostsStats = computed(() => getShrinkedNumber(props.postsStatistic));

    return { amountFollowers, amountFollowing, formattedPostsStats };
  },
});
